module.exports = __webpack_public_path__ + "media/images/shark/Shark3-p-1080-bec35ced5a44c39bd77460fe605bca65.png";